import { Button, LinkButton } from '@cian/ui-kit';
import { Responsive } from '@cian/ui-kit/responsive';

import * as styles from './BookButton.css';
import { IBookButtonProps } from './types';

export const BookButton = (props: IBookButtonProps) => {
  const { title, offerUrl } = props;

  return (
    <>
      <Responsive phone>
        <div className={styles['button-phone-container']}>
          <LinkButton fullWidth href={offerUrl} target="_blank" rel="noopener noreferrer">
            {title}
          </LinkButton>
        </div>
      </Responsive>

      <Responsive tablet desktop>
        <a href={offerUrl} className={styles['button-tablet']} target="_blank" rel="noopener noreferrer">
          <Button size="XS">{title}</Button>
        </a>
      </Responsive>
    </>
  );
};
